import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'
import FiatTransactionsListPage from './FiatTransactionsListPage.vue'
import FiatTransactionDetailPage from './FiatTransactionDetailPage.vue'

export const fiatTransactionsRoutes: RouteRecordRaw[] = [
  {
    path: routes.TREASURY_FIAT_TRANSACTIONS_LIST,
    name: 'treasury.fiatTransactions.list',
    component: FiatTransactionsListPage,
    meta: {
      layout: 'admin',
      requiresAuth: true,
      title: 'All transactions',
      activeMenu: 'Treasury',
    },
  },
  {
    path: routes.TREASURY_FIAT_TRANSACTIONS_DETAIL,
    name: 'treasury.fiatTransactions.detail',
    component: FiatTransactionDetailPage,
    meta: {
      layout: 'admin',
      requiresAuth: true,
      title: 'Transaction detail',
      activeMenu: 'Treasury',
    },
  },
]
